module.exports = __webpack_public_path__ + "static/media/healthcare-mobile-app-patient-dashboard-video-consultation.4cbe8481.webp";